var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoicon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 56,
    viewBox: "0 0 66 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_349_6658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5581 0L0.119141 10.4733L16.5581 20.9467L32.9999 10.4733L16.5581 0Z",
    fill: "#0061FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4405 0L33 10.4743L49.4405 20.9486L65.881 10.4743L49.4405 0Z",
    fill: "#0061FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.119141 31.4216L16.5581 41.8949L32.9999 31.4216L16.5581 20.9482L0.119141 31.4216Z",
    fill: "#0061FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4404 20.9482L33 31.4225L49.4404 41.8967L65.8807 31.4225L49.4404 20.9482Z",
    fill: "#0061FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5596 45.4089L33.0013 55.8822L49.4403 45.4089L33.0013 34.9355L16.5596 45.4089Z",
    fill: "#0061FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349_6658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65.7615,
    height: 56,
    fill: "white",
    transform: "translate(0.119141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoicon5);
export default __webpack_public_path__ + "static/media/logoicon5.6b48c013144fd7457c0b4b10036667a8.svg";
export { ForwardRef as ReactComponent };